import React from 'react';
import { Navigate } from 'react-router-dom';

/** Legacy path — referral approval config now lives under Configuration. */
export default function ReferralApprovalConfigPage() {
  return <Navigate to="/management/booking-settings?tab=referrals" replace />;
}
